module.exports = __webpack_public_path__ + "img/1.f6d66bf7.jpg";